import { Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { CircularProgress, Stack } from '@mui/material'
import AppLayout from '@/components/app-layout/AppLayout'
import AppTopBarLite from '@/components/app-top-bar/AppTopBarLite'
import MainPage from './lite/MainPage'
import NotFound from './NotFound'

export default function ApplicationLite() {
  return (
    <AppLayout header={<AppTopBarLite />} isLite>
      <Suspense
        fallback={
          <Stack alignItems="center" sx={{ p: 4 }}>
            <CircularProgress />
          </Stack>
        }
      >
        <Routes>
          <Route
            path="select-integration"
            element={<div style={{ margin: '10px' }}>Select integration</div>}
          />

          <Route
            path="set-account-name"
            element={<div style={{ margin: '10px' }}>Set account name</div>}
          />

          <Route path="/" element={<MainPage />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </AppLayout>
  )
}
